import { Vector3 } from "three";
import { EigenvalueDecomposition } from "ml-matrix";
export class PlaneFitter {
    static fitPlane(data) {
        const means = [];
        const variances = [];
        const xCoords = [];
        const yCoords = [];
        const zCoords = [];
        for (let i = 0; i < data.length; i++) {
            xCoords[i] = data[i].x;
            yCoords[i] = data[i].y;
            zCoords[i] = data[i].z;
        }
        const coords = [xCoords, yCoords, zCoords];
        // Calculate means and variances
        for (let i = 0; i < coords.length; i++) {
            let total = 0;
            for (let j = 0; j < coords[i].length; j++) {
                total += coords[i][j];
            }
            means[i] = total / coords[i].length;
            let varianceTotal = 0;
            for (let j = 0; j < coords[i].length; j++) {
                const diff = coords[i][j] - means[i];
                varianceTotal += diff * diff;
            }
            variances[i] = varianceTotal / coords[i].length;
        }
        const covariance = [];
        // Calculate covariance
        for (let k = 0; k < coords.length; k++) {
            covariance.push([]);
            for (let l = 0; l < coords.length; l++) {
                let covarianceTotal = 0;
                for (let j = 0; j < coords[0].length; j++) {
                    const diff1 = coords[k][j] - means[k];
                    const diff2 = coords[l][j] - means[l];
                    covarianceTotal += diff1 * diff2;
                }
                covariance[k].push(covarianceTotal / coords[0].length);
            }
        }
        const transCovariance = [];
        for (let i = 0; i < covariance.length; i++) {
            transCovariance.push([]);
            for (let j = 0; j < covariance[i].length; j++) {
                transCovariance[i].push(covariance[j][i]);
            }
        }
        const { realEigenvalues, eigenvectorMatrix } = new EigenvalueDecomposition(covariance);
        let min = Number.MAX_SAFE_INTEGER;
        let result = [];
        for (let i = 0; i < realEigenvalues.length; i++) {
            if (realEigenvalues[i] < min) {
                min = realEigenvalues[i];
                result = eigenvectorMatrix.getColumn(i);
            }
        }
        return new Vector3(result[0], result[1], result[2]);
    }
}
//# sourceMappingURL=PlaneFitter.js.map